import { defineMessages } from "react-intl";

export const ColorPickerFieldControlMessages = defineMessages({
  selectColorPlaceholder: {
    defaultMessage: "Select color",
    id: "gzhhds",
  },
});
